
export class TemplateEntityType {

  static ASI = 0;

  static ASITABLE = 1;

  static APOTEMPLATE = 2;

  static PEOPLETEMPLATE = 3;
}


export class TemplateType {
  static CAP_ADDRESS = 0;

  static CAP_PARCEL = 1;

  static CAP_OWNER = 2;
}
